fx.ns("filters.photofilters", class NuageFilter extends filters.photofilters.BaseFilter {
    
    constructor(parameters)
    {
        super(parameters);
        
        this.amount = this.params.amount;        
    }

    apply(SVGElement)
    {
        
        super.apply(SVGElement)
        
        let baseSVG = SVGElement.parent();

        let gradient = baseSVG.gradient('radial', function(stop) {
              stop.at(0.4, 'rgba(255,255,255,1)')
              stop.at(0.9, 'rgba(255,255,255,0)')
            })
            
        let ellipse = baseSVG.ellipse(SVGElement.width()  , SVGElement.height() )
                                 .move(0 , 0 )
                                 .fill(gradient)
        let mask = baseSVG.mask();

        mask.add(ellipse)
        
        SVGElement.maskWith(mask);

        this.elements.push(gradient);
        this.elements.push(mask);
        this.elements.push(ellipse);

    }

    move(x, y)
    {
        for (let i = 0; i < this.elements.length; i++)
        {
            if (this.elements[i].type == "ellipse")
                this.elements[i].move(x,y);
        }
    }

    resize(width, height)
    {
       for (let i = 0; i < this.elements.length; i++)
       {
            if (this.elements[i].type == "ellipse")
                this.elements[i].size(width, height).move(0 , 0 ); 
        }
    }
   

    filterFCN(add)
    {
         add.componentTransfer({
                rgb: { type: 'linear', slope: this.amount, intercept: -(0.3 * this.amount) + 0.3 }
            })
    }

    clear(){
        
        if (this.SVGElement)
            this.SVGElement.unmask();

        super.clear();
    }


});
